import { ErrorMessage, Field, Formik } from "formik";
import React from "react";
import { Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { imageUrls } from "../constants/images";
import { Texterror } from "../constants/Texterror";
import "../../styles/auth.scss";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { UserSignin } from "../redux/actions/authActions";
import { SignIn } from "../constants/Validation";
export const Login = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.auth);
  const handleLogin = (values) => {
    dispatch(UserSignin(values, history));
  };
  localStorage.removeItem("newPatient");
  return (
    <div className="login_ss">
      <Container className="p-3">
        <Row className="d-flex justify-content-center align-items-center h-100">
          <Col>
            <div className="open_form">
              <div className="main_box">
                <div className="p-5 card-body w-100 d-flex flex-column">
                  <Link to={`/`}>
                    <img
                      src={imageUrls.logo}
                      className="img-fluid"
                      alt="Phone"
                    />
                  </Link>
                  <div className="mini_kog">
                    <h2 className="fw-bold mb-2 text-center">Welcome Back!</h2>

                    <p className="mb-4 text-center">
                      Please enter your email address and password!
                    </p>

                    <Formik
                      initialValues={{
                        user_email: "",
                        user_password: "",
                      }}
                      validationSchema={SignIn}
                      onSubmit={(values, { resetForm }) => {
                        handleLogin(values);
                        resetForm();
                      }}
                    >
                      {({ values, touched, errors, handleSubmit }) => (
                        <Form onSubmit={handleSubmit}>
                          <div className="mb-3">
                            <Field
                              className={`form-control ${
                                touched.user_email && errors.user_email
                                  ? "is-invalid"
                                  : ""
                              }`}
                              name="user_email"
                              placeholder="Email"
                              type="input"
                              value={values.user_email}
                            />
                            <ErrorMessage
                              name="user_email"
                              component={Texterror}
                            />
                          </div>

                          <div className="mb-3">
                            <Field
                              className={`form-control ${
                                touched.user_password && errors.user_password
                                  ? "is-invalid"
                                  : ""
                              }`}
                              placeholder="Password"
                              name="user_password"
                              type="password"
                              value={values.user_password}
                            />
                            <ErrorMessage
                              name="user_password"
                              component={Texterror}
                            />
                          </div>
                          <div className="op mb-2">
                            <Form.Check type="checkbox" label="Remember me" />
                            <Link to={`/forgotpassword`} className="forgot">
                              Forgot Password?
                            </Link>
                          </div>
                          <button type="submit" className="sign_btn  !w-full">
                            {isLoading ? <Spinner /> : "Sign in"}
                          </button>
                        </Form>
                      )}
                    </Formik>

                    <div className="newlane my-4"></div>
                    <div className="text-center text-sm">
                      Are you a new user?{" "}
                      <Link to={`/register`} className="forgot">
                        <h6>
                          <b>Sign Up Here</b>
                        </h6>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="second_box">
                <img src={imageUrls.signin} alt="doctor" />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
